<template>
<div>
    <a-date-picker @change="ChangeDataDate"></a-date-picker>
    <div id="content">
        <a-table id="left" :columns="columns" :data-source="dataSource" rowKey="deviceid"
            :pagination='true' :customRow="customRow">
            <template slot="name" slot-scope="deviceid">
            {{ deviceid }} - {{ deviceid }}
            </template>
        </a-table>
        <div id="healthyMap"></div>
    </div>
</div>
</template>

<script>    
const moment = require('moment');
import request from "../../utils/request";
import domain from "../../domain";
import {getClientId} from '../../utils/auth'

export default {
    data() {
        return {
            amap: null,
            clientid: 0,
            gnss_list:[],
            start_date:"",
            first: true,
            columns: [
                {
                    title: this.$t("message")['OverView.listview.title'],
                    dataIndex: 'deviceid',
                }
            ],
            dataSource: []
        }
    },   
    methods: {
        setMapWithPoints(gnss_list,idx){
            if(!this.amap){
                var map = new BMapGL.Map("healthyMap");
                this.amap = map;
            }
            if(gnss_list.length==0){
                return;
            }
            
            var convertor = new BMapGL.Convertor(); 
            var pointArr = []; 
            var total = 0;         
            for(var i=0;i<gnss_list.length;i++){ 
                var gnss = gnss_list[i];
                var original = new BMapGL.Point(gnss.lng, gnss.lat);
                pointArr.push(original);
                total+=1;
                if(total>5){
                    if(i==gnss_list.length-1){
                        this.first = false;
                    }
                    convertor.translate(pointArr, COORDINATES_WGS84, COORDINATES_BD09, this.translateCallback);
                    pointArr = [];
                    total = 0;
                }
            }
            if(total<=5 && pointArr.length>0){
                this.first = false;
                convertor.translate(pointArr, COORDINATES_WGS84, COORDINATES_BD09, this.translateCallback);
            }

            var zoomCtrl = new BMapGL.ZoomControl();
            this.amap.addControl(zoomCtrl);
            var scaleCtrl = new BMapGL.ScaleControl();
            this.amap.addControl(scaleCtrl);
        },

        setMapCenter(gnss){
            if(!this.amap){
                var map = new BMapGL.Map("healthyMap");
                this.amap = map;
            }
            let point = new BMapGL.Point(gnss.lng, gnss.lat);
            this.amap.centerAndZoom(point, 13);
        },

        translateCallback(data){
            if(data.status != 0){
                return;
            }
            if(this.first==false){
                let first = data.points[0];
                this.amap.centerAndZoom(first, 13);
            }
            var myIcon = new BMapGL.Icon("http://api8.iwown.com/dist/snapshot/marker.png", new BMapGL.Size(14, 18),{
                anchor: new BMapGL.Size(7, 9)
            });

            for(var i=0;i<data.points.length;i++){
                var point = data.points[i]; 
                var marker = new BMapGL.Marker(point);
                marker.setIcon(myIcon);
                this.amap.addOverlay(marker);
                var content = this.gnss_list[i].deviceid;
                var label = new BMapGL.Label(content, {  
                    position: point,                         
                    offset: new BMapGL.Size(10, 10)
                });
                this.amap.addOverlay(label);
                label.setStyle({ 
                    color: '#2284FF',
                    fontSize: '12px',
                    border: '1px solid #2284FF',
                    borderRadius: '5px'
                })
            }
            this.first = true;
        },

        getLatestGnssData(clientid,data_date_str){
            let that = this
            let url_req = domain.URLS.all_latest_gnss_url;
            request({
                //调用接口
                method: "GET",
                url: url_req,
                params: {
                    clientid: clientid,
                    start_date: data_date_str
                }
            }).then(
                function (response) {
                    //接口返回数据
                    let list = response.data.Data;
                    that.gnss_list = list;
                    that.SetListViewDs(list);
                    that.setMapWithPoints(list,0);
                },
                function (error) {
                    console.log(error.data)
                }
            )
        },
        ChangeDataDate(val){
            let date_str = val.format('YYYY-MM-DD');
            this.start_date = date_str;
            this.getLatestGnssData(this.clientid,this.start_date);
        },
        SetListViewDs(list){
            this.dataSource.splice(0,this.dataSource.length);
            for(let i=0;i<list.length;i++){
                let obj = {"deviceid":list[i]["deviceid"]};
                this.dataSource.push(obj);
            }
        },
        customRow(record, index) {
            let that = this;
            return {
                on: {
                    click: () => {
                        console.log("record:", record, `点了第${index}行`);
                        that.setMapCenter(that.gnss_list[index]);
                    },
                },
            };
        },        
        setCurrentLocation(){
            if ("geolocation" in navigator) {
                navigator.geolocation.getCurrentPosition(
                    position => {
                        let latitude = position.coords.latitude;
                        let longitude = position.coords.longitude;
                        this.setMap(longitude,latitude);
                    },
                    error => {
                        console.log(error);
                        this.setMap(0,0);
                    }
                );
            } else {
                this.setMap(0,0);
            }
        },
        calculateDistance(lat1, lon1, lat2, lon2) {
            // The radius of the Earth in kilometers
            const R = 6371;
            // Convert latitude and longitude from degrees to radians
            const lat1Rad = (lat1 * Math.PI) / 180;
            const lon1Rad = (lon1 * Math.PI) / 180;
            const lat2Rad = (lat2 * Math.PI) / 180;
            const lon2Rad = (lon2 * Math.PI) / 180;

            // Haversine formula
            const dlat = lat2Rad - lat1Rad;
            const dlon = lon2Rad - lon1Rad;
            const a =
                Math.sin(dlat / 2) ** 2 +
                Math.cos(lat1Rad) * Math.cos(lat2Rad) * Math.sin(dlon / 2) ** 2;
            const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
            const distance = R * c;
            return distance;
        },
        findClosestPoint(points) {
            // Set a distance threshold (adjust as needed)
            const threshold = 50; // kilometers
            let closestPoint = null;
            let maxNearbyCount = 0;
            for (let i = 0; i < points.length; i++) {
                let nearbyCount = 0;

                for (let j = 0; j < points.length; j++) {
                    if (i !== j) {
                        const distance = this.calculateDistance(
                        points[i].lat,
                        points[i].lng,
                        points[j].lat,
                        points[j].lng
                        );

                        if (distance <= threshold) {
                        nearbyCount++;
                        }
                    }
                }

                if (nearbyCount > maxNearbyCount) {
                    maxNearbyCount = nearbyCount;
                    closestPoint = points[i];
                }
            }
            return closestPoint;
        }
    },
    created() {
        let today = new Date();
        let momentDate = moment(today);
        this.start_date = momentDate.subtract(7, 'day').format('YYYY-MM-DD')
        this.clientid = getClientId();
        this.getLatestGnssData(this.clientid,this.start_date);
    },
    mounted: function() {

    }
}
</script>

<style scoped>
#healthyMap{
  width: 70%;
  height: 660px;
}

#content {
  margin-top: 20px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: top;
}

#left {
    width: 25%;
    height: 660px;
    border: 1px solid #d3d7d4;
    border-radius: 5px;
    margin-right: 10px;
}

</style>
